import { forwardRef } from 'react';

import { AppData, apps } from '../../AppsDetailsValues/AppsDetailsValues';
import { getAppEcosystem } from '../../getAppEcosystem';
import { Popover, PopoverActions } from '../../Popover';

import { AppButton } from './AppButton';
import styles from './RandstadAppsPopup.module.scss';
import { Props } from './RandstadAppsPopup.types';

export const RandstadAppsPopup = forwardRef<PopoverActions, Props>(
  ({ onItemClick, isProd, brandCode, ...popupProps }, ref) => {
    let activeApps: AppData[] = apps;
    if (brandCode) {
      activeApps = apps.filter(app => getAppEcosystem({ brand: brandCode }).includes(app.name));
    }
    return (
      <Popover ref={ref} {...popupProps}>
        <div className={styles.container}>
          {activeApps.map(({ icon, name, link }) => (
            <AppButton
              key={name}
              icon={isProd ? icon.prod : icon.uat}
              name={name}
              link={isProd ? link.prod : link.uat}
              onClick={onItemClick}
            />
          ))}
        </div>
      </Popover>
    );
  }
);
